<!--门店休息设置-->
<template>
  <div>
    <el-card class="operate-container" shadow="never" style="margin-top: 0px;">
      <div class="top-con-2">
        <div style="margin-left: 30px; font-size: 16px;">门店休息日:</div>
        <el-checkbox-group style="margin-left: 10px; margin-top: 2px;"
          @change="checkedDayChanged"
          v-model="checkedDay"
          :min="0"
          :max="7">
          <el-checkbox v-for="day in week" :label="day.value" :key="day.value" style="font-size: 16px;">{{day.lable}}</el-checkbox>
        </el-checkbox-group>
      </div>
    </el-card>
    <el-container class="class-root-container">
      <div class="class-date-item"  v-for="(item ,index) in restDays" v-bind:key="index">
        <el-card :style="getBgColor(item.isToday)" class="class-date-item-card">
          <el-row>
            <el-col :span="4">
              <icon class="el-icon-date"></icon>
            </el-col>
            <el-col :span="20">
              {{item.dayDes}}
            </el-col>
          </el-row>
          <el-row style="margin-top: 15px ;" >
            <el-col :span="4" style="margin-top: 2px">
              <icon class=" el-icon-c-scale-to-original"></icon>
            </el-col>
            <el-col :span="20" style="font-size: 20px">
              {{item.week}}
            </el-col>
          </el-row>
          <el-row style="margin-top: 40px">
            <el-col :span="24">
              <div v-if="item.rest">
                <el-button type="success" circle @click="onClickRest(item)">休</el-button>
              </div>
              <div v-else>
                <el-button style="margin-right: 0px;" type="primary" class="operator-btn" circle  @click="onClickRest(item)">班</el-button>
              </div>
            </el-col>
          </el-row>
        </el-card>
      </div>
    </el-container>
    <el-container class="class-root-container">
      <div class="class-date-item"  v-for="(item ,index) in restDaysTemp" v-bind:key="index">
        <el-card class="class-date-item-card">
          <el-row>
            <el-col :span="4">
              <icon class="el-icon-date"></icon>
            </el-col>
            <el-col :span="20">
              {{item.dayDes}}
            </el-col>
          </el-row>
          <el-row style="margin-top: 15px ;" >
            <el-col :span="4" style="margin-top: 2px">
              <icon class=" el-icon-c-scale-to-original"></icon>
            </el-col>
            <el-col :span="20" style="font-size: 20px">
              {{item.week}}
            </el-col>
          </el-row>
          <el-row style="margin-top: 40px">
            <el-col :span="24">
              <div v-if="item.rest">
                <el-button type="success" circle @click="onClickRest(item)">休</el-button>
              </div>
              <div v-else>
                <el-button style="margin-right: 0px;" type="primary" class="operator-btn" circle  @click="onClickRest(item)">班</el-button>
              </div>
            </el-col>
          </el-row>
        </el-card>
      </div>

    </el-container>
    <el-card class="operate-container" style="width: 100%; margin-top: 15px;" shadow="never">
      <el-button type="primary" style="width: 160px;" class="operator-btn" icon="el-icon-circle-check" @click="save()">保存</el-button>
    </el-card>
  </div>
</template>

<style scoped>
  .top-con-2{
    width: 90%;
    height: auto;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: start;
    text-align: center;
    margin-top: 24px;
    margin-bottom: 24px;
  }
  .class-root-container{
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    text-align: center;
    border: 1px solid #bdbdbd;
    border-radius: 8px;
    padding: 15px 0px 15px 0px;
    margin-top: 10px;
    background: #FFFFFF;
  }
  .class-date-item{
    width: 12%;
    height: 180px;
    font-size: 10px;
    border-radius: 8px;
    background-color: #FFFFFF;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
  }
  .class-date-item-card{
    width: 100%;
    height: 100%;
  }
</style>

<script>


  import timeUtils from "../../../utils/timeUtils";
  import {formatDate} from "../../../utils/date";
  import {setStoreRestDay} from "../../../api/StoreSetting";
  import messageUtils from "../../../utils/messageUtils";
  import globaldata from "../../../utils/globaldata";

  export default {
    name: 'StoreRest',
    props: {
       rests:Object,
      lessonTemplateId:null,
    },
    data() {
      return {

         week: [
           {lable:'周一',value:1},
           {lable:'周二',value:2},
           {lable:'周三',value:3},
           {lable:'周四',value:4},
           {lable:'周五',value:5},
           {lable:'周六',value:6},
           {lable:'周日',value:7},
         ],
         checkedDay: [],


         restDays:[

         ],

        restDaysTemp:[

        ],
      }
    },
    created(){


    },
    methods: {
      initData(){
        this.restDays = [];
        this. restDaysTemp = [];
        let nowDay = new Date(); //
        this.calcaDay(nowDay,this.restDays);

        let tDay = nowDay.getTime() + timeUtils.getDayMilSec()*7;
        tDay = new Date(tDay);
        this.calcaDay(tDay,this.restDaysTemp);

      },
      calcaDay(startDay,restDays){
        let nowDay = startDay; //
        let nowWeek  =nowDay.getDay(); //今天是周几
        let weekIndex = nowWeek;
        if (weekIndex == 0){
          //0表示周日 所以这里改成周一
          weekIndex = 7;
        }
        let dm = timeUtils.getDayMilSec();
        for (let i  = 1;i<= 7;++i){
          let dayTime =  nowDay.getTime() + (dm)*(i-nowWeek);
          let date = new Date(dayTime);
          let week = timeUtils.getWeekDay(date);

          let dayDes = formatDate(date, 'yyyy-MM-dd');
          let isToday = false;
          if (i == nowWeek) {
            isToday = true;
          }
          let fd = formatDate(date, 'yyyy-MM-dd');
          let dayInt  = timeUtils.transDayInt(fd)
          let rest =  {
            day: fd,
            dayInt:dayInt,
            dayDes: dayDes,
            week:week,
            isToday:isToday,
            rest:false,
            restDes:"班",
          }
          restDays.push(rest);
        }

      },

      getBgColor(today){
        if (today){
          let  styleObject ={
            backgroundColor:'#99b9bf'
          }
          return styleObject;
        }else {
          let  styleObject ={}
          return styleObject;
        }
      },

      refreshData(data){
        console.log("refreshData data",data)
        this.initData();
        let restWeeksSetting = data.restWeeksSetting;
        this.checkedDay = data.restDay;
        this.setRestDays(this.restDays,restWeeksSetting,);
        this.setRestDays(this.restDaysTemp,restWeeksSetting);
      },

      setRestDays(restDays,restWeeksSetting){
        for (let i = 0;i< restDays.length;++i){
          let restDay = restDays[i];
          for (let j = 0;j< restWeeksSetting.length ;++j){
            if (restDay.dayInt == restWeeksSetting[j]){
              restDay.rest = true;
            }
          }
        }
      },

      onClickRest(item){
        item.rest = !item.rest;
      },
      checkedDayChanged(val){

      },
      save(){
        /**
         * 多周的休息日设置(日期的数组 20211313)
         */
        let  restWeeksSetting = [];
        for (let i = 0;i< this.restDays.length;++i){
          if(this.restDays[i].rest == false){
            continue;
          }
          restWeeksSetting.push(this.restDays[i].dayInt)
        }
        for (let i = 0;i< this.restDaysTemp.length;++i){
          if(this.restDaysTemp[i].rest == false){
            continue;
          }
          restWeeksSetting.push(this.restDaysTemp[i].dayInt)
        }
        let restDay = this.checkedDay;
        let param = {
          storeFrontId:globaldata.getAdminStore().storeFrontId,
          lessonTemplateId:this.lessonTemplateId,
          restDay:restDay,
          restWeeksSetting:restWeeksSetting
        }

        setStoreRestDay(param).then(response =>
        {
          let  data = response.data;
          if (data == true){
            messageUtils.successMsg(this,"保存成功");
          }else {
            messageUtils.successMsg(this,"保存失败");
          }

        })

      },

      onGetBaseRests(){
        return this.restDays;
      }
    },


  }
</script>






// WEBPACK FOOTER //
// src/views/my-store/component/StoreRest.vue